/**
 * @desc sku报价修改
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierQuotationUpdateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
